<template>
  <div>
    <Loading v-if="loading" :loading="loading" />
    <div style="padding: 0 20px;" v-else>
      <!-- 释放文件 -->
      <ReleaseFile id="releasefile" v-if="releasefile" :releasefile="releasefile" />
      <div class="pagination-wrap">
        <Pagination
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :totalSize="totalSize"
          :current_page="currentPage"
          :page-size="pageSize"
          customTotal
        />
      </div>
    </div>
    <detail-footer/>
  </div>
</template>

<script>
import { getTaskReportDropped } from 'services/report'
import Pagination from '@/components/common/Pagination'
import ReleaseFile from '../ReleaseFile'
import { mapState } from 'vuex'

export default {
  name: 'release',
  components: {
    ReleaseFile,
    Pagination
  },
  data() {
    return {
      releasefile: {},
      loading: true,
      currentPage: 1,
      totalSize: 0
    }
  },
  computed: {
    ...mapState(['report']),
    taskId() {
      return this.$route.params.taskId
    },
    pageSize({ report }) {
      return report.dropped.pageSize
    },
    page({ report }) {
      return report.dropped.page
    }
  },
  watch: {
    page: {
      handler: function(val) {
        if (val) this.currentPage = val
      },
      immediate: true
    }
  },
  methods: {
    async init() {
      await getTaskReportDropped(this.taskId, {
        total: true
      }).then((res) => {
        this.totalSize = res.total
      })
      this.getList()
    },
    async getList() {
      await getTaskReportDropped(this.taskId, {
        page: this.currentPage,
        size: this.pageSize
      }).then((res) => {
        this.releasefile.dropped = res.dropped
      })
      this.loading = false
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.currentPage = page
      this.getList()
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.pagination-wrap {
  padding-bottom: 24px;
  margin-right: -20px;
}
</style>
